var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.error && _vm.src)?_c('img',{staticClass:"user-avatar",attrs:{"src":_vm.src},on:{"error":_vm.onError}}):_c('Icon',{staticClass:"user-avatar",attrs:{"name":"user"}})
}
var staticRenderFns = []

export { render, staticRenderFns }